import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_action sub_page" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "state_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "state_list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "state_status" }
const _hoisted_7 = {
  key: 0,
  class: "ing"
}
const _hoisted_8 = {
  key: 1,
  class: "end"
}
const _hoisted_9 = {
  key: 2,
  class: "remaining_time"
}
const _hoisted_10 = { class: "state_title" }
const _hoisted_11 = { class: "state_create_date" }
const _hoisted_12 = { class: "state_info" }
const _hoisted_13 = {
  key: 1,
  class: "tr_div"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($setup.state.list.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.list, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event: any) => ($setup.selectWeek(item.idx))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      (item.state === 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "진행중"))
                        : (_openBlock(), _createElementBlock("p", _hoisted_8, "종료")),
                      (new Date() < new Date(item.endDate))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($setup.CommonUtils.getDDayHour(new Date(item.endDate))), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(item.name), 1),
                    _createElementVNode("p", _hoisted_11, "등록일 : " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", false)), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", null, [
                        _cache[0] || (_cache[0] = _createElementVNode("label", { for: "" }, "활동기간", -1)),
                        _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.startDate), ".", false)) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.endDate), ".", false)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("label", { for: "" }, "액션활동", -1)),
                        _createTextVNode(" " + _toDisplayString(item.cntEntire) + " 명 참여 ", 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "" }, "게시글 수", -1)),
                        _createTextVNode(" " + _toDisplayString(item.cntBoard) + "개 ", 1)
                      ])
                    ])
                  ], 8, _hoisted_5))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", {
                  class: "tb_subject",
                  style: {"text-align":"center","width":"100%"}
                }, "등록된 액션 활동이 없습니다.", -1)
              ]))]))
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal
        }, null, 8, ["type", "title", "content", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}